/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Property_Legal_GenerateInputs */

const cs_property_legal_generate = /** @type {(inputs: Property_Legal_GenerateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vygenerovat nájemní PDF`)
};

const en_property_legal_generate = /** @type {(inputs: Property_Legal_GenerateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Generate lease PDF`)
};

/**
* | output |
* | --- |
* | "Generate lease PDF" |
*
* @param {Property_Legal_GenerateInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const property_legal_generate = /** @type {((inputs?: Property_Legal_GenerateInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Property_Legal_GenerateInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_property_legal_generate(inputs)
	return cs_property_legal_generate(inputs)
});